module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_FR-793d7c5b8b2c70a50e97fa513acc2bab.svg";